import type { SynchronizedWith } from '@openx/types/deal';
import type { DealDetailsSectionProps } from '../../types';
import { AmazonSyncErrorsSection } from './sections/AmazonSyncErrorsSection';
import { AmazonSyncStatusSection } from './sections/AmazonSyncStatusSection';

export type DealAmazonSync = {
  synchronized_with: { amazon_sync: NonNullable<SynchronizedWith['amazon_sync']> };
};

export const DealAmazonSyncTab = <T extends DealAmazonSync = DealAmazonSync>({ deal }: DealDetailsSectionProps<T>) => {
  const amazonSync = deal.synchronized_with.amazon_sync;

  return (
    <>
      <AmazonSyncStatusSection amazonSync={amazonSync} />
      <AmazonSyncErrorsSection
        amazonLastSyncError={amazonSync.amazon_last_sync_error}
        syncStatus={amazonSync.amazon_sync_status}
      />
    </>
  );
};
